import { IOption } from "~/graphql/queries/optionModeration/optionsPendingImageModeration";

export default function getOptionImage(option: IOption) {
  if (option.image) {
    return option.image;
  }

  return option.product.images.find(image => image.deletedAt === null) || null;
}



// WEBPACK FOOTER //
// ./src/util/getOptionImage.ts